export default __webpack_public_path__ + "static/media/or-logo-white.442db7e0.png";